import React from 'react';

export default function FireFlameBlock() {
  return (
    <svg
      width='42'
      height='41'
      viewBox='0 0 42 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_4454_83006)'>
        <g clip-path='url(#clip0_4454_83006)'>
          <rect
            x='1'
            width='40'
            height='40'
            rx='12'
            fill='url(#paint0_linear_4454_83006)'
          />
          <g
            clip-path='url(#clip1_4454_83006)'
            filter='url(#filter1_dd_4454_83006)'
          >
            <path
              d='M21 32C15.486 32 11 27.514 11 22C11 18.642 12.505 16.541 14.765 14.42L17.213 12.121L16.421 15.384C16.146 16.52 16.074 19.99 17.533 21.845C18.144 22.622 18.951 23 20 23C21.107 23 21.986 22.116 22 20.987C22.014 19.87 21.542 18.945 21.042 17.967C20.53 16.965 20 15.93 20 14.672C20 11.961 21.412 9.504 21.472 9.401L22.3 7.979L23.181 9.37C24.03 10.709 25.175 11.957 26.284 13.164C28.603 15.688 31.001 18.3 31.001 22.001C31.001 27.515 26.515 32.001 21.001 32.001L21 32Z'
              fill='url(#paint1_linear_4454_83006)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_di_4454_83006'
          x='0.5'
          y='0'
          width='41'
          height='41'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4454_83006'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_4454_83006'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_4454_83006'
          />
        </filter>
        <filter
          id='filter1_dd_4454_83006'
          x='-21'
          y='-18.1015'
          width='84'
          height='84'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='10' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4454_83006'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_4454_83006'
            result='effect2_dropShadow_4454_83006'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_4454_83006'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_4454_83006'
          x1='21'
          y1='0'
          x2='21'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#29282C' />
          <stop offset='1' stop-color='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_4454_83006'
          x1='10.8455'
          y1='3.04327'
          x2='29.2086'
          y2='25.4537'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_4454_83006'>
          <rect x='1' width='40' height='40' rx='12' fill='white' />
        </clipPath>
        <clipPath id='clip1_4454_83006'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(9 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
